module.exports = __webpack_public_path__ + "static/media/wheel.49df1f8a.svg";